/* eslint-disable no-undef */
import { useEffect, useRef } from "react";

const useStickyScrolling = ({
  elRef = null,
  offset = 80,
  toggleHeight = 0,
  defaultTop = 0,
  hookCondition = [],
  scrollCondition = true,
  showAfter = 0,
  callBack = null,
  onToggle = null,
}: any) => {
  const scrollPosRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollCondition) {
        const { top } = document.body.getBoundingClientRect();
        callBack?.(-top, -scrollPosRef.current);
        if (elRef?.current && Math.abs(top - scrollPosRef.current) >= offset) {
          if (-top > showAfter) {
            if (elRef?.current?.style && showAfter) {
              elRef.current.style.display = `block`;
            }
            if (top > scrollPosRef.current && !window.manualScrollTrigger) {
              elRef.current.style.top = `${defaultTop}px`;
              onToggle?.(false, top);
            } else {
              onToggle?.(true, top);
              elRef.current.style.top = `${defaultTop - toggleHeight}px`;
            }
          } else if (showAfter) {
            if (elRef?.current?.style) {
              elRef.current.style.display = `none`;
            }
          }
          scrollPosRef.current = top;
        }
      }
    };
    if (elRef?.current) {
      elRef.current.style.top = `${defaultTop}px`;
    }
    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, hookCondition);
};

export default useStickyScrolling;
